function detail(event) {
  return event.detail
}

export default detail
